module.exports = __webpack_public_path__ + "88c769237e89d5ca8f95a76ae4394c06.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader/dist/cjs.js!./assets/major.png
// module id = 97
// module chunks = 0